var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.5C6 6.22386 6.22386 6 6.5 6H17.5C17.7761 6 18 6.22386 18 6.5C18 6.77614 17.7761 7 17.5 7H6.5C6.22386 7 6 6.77614 6 6.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.5C6 9.22386 6.22386 9 6.5 9H17.5C17.7761 9 18 9.22386 18 9.5C18 9.77614 17.7761 10 17.5 10H6.5C6.22386 10 6 9.77614 6 9.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.5C6 12.2239 6.22386 12 6.5 12H17.5C17.7761 12 18 12.2239 18 12.5C18 12.7761 17.7761 13 17.5 13H6.5C6.22386 13 6 12.7761 6 12.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15.5C6 15.2239 6.22386 15 6.5 15H17.5C17.7761 15 18 15.2239 18 15.5C18 15.7761 17.7761 16 17.5 16H6.5C6.22386 16 6 15.7761 6 15.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3C4.22614 3 4 3.22614 4 3.5V20.4597L5.68765 19.1096C5.85768 18.9735 6.09618 18.9632 6.27735 19.084L9 20.8991L11.7226 19.084C11.8906 18.972 12.1094 18.972 12.2774 19.084L15 20.8991L17.7226 19.084C17.9038 18.9632 18.1423 18.9735 18.3123 19.1096L20 20.4597V3.5C20 3.22614 19.7739 3 19.5 3H4.5ZM3 3.5C3 2.67386 3.67386 2 4.5 2H19.5C20.3261 2 21 2.67386 21 3.5V21.5C21 21.6922 20.8898 21.8674 20.7166 21.9507C20.5434 22.0339 20.3377 22.0105 20.1877 21.8904L17.9731 20.1188L15.2774 21.916C15.1094 22.028 14.8906 22.028 14.7226 21.916L12 20.1009L9.27735 21.916C9.1094 22.028 8.8906 22.028 8.72265 21.916L6.02685 20.1188L3.81235 21.8904C3.66226 22.0105 3.45664 22.0339 3.28341 21.9507C3.11017 21.8674 3 21.6922 3 21.5V3.5Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.fa4d8c42058297c696b7e8edaa3ad7c7.svg";
export { ForwardRef as ReactComponent };